import Component from './ColumnChooserFooter.component';

export default Component;
